<template>
  <div>
    <div class="flex mb-4 justify-between">
      <div class="flex-grow">
        <h4 class="mb-4" v-if="language == 'en'">Recommendation</h4>
        <h4 class="mb-4" v-else>推荐</h4>
      </div>
    </div>

    <div class="flex mb-4 justify-between">
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language == 'en'">Recommendation</h5>
        <h5 class="mb-2" v-else>推荐</h5>
        <p>{{language == 'en' ? recommendation.solution : recommendation.solution_zh}}</p>
      </div>
      <div class="flex-grow">
        <h5 class="mb-2" v-if="language == 'en'">Products</h5>
        <h5 class="mb-2" v-else>产品</h5>
        <p v-for="(product, index) in recommendation.products" :key="index">{{product.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["recommendation", "language"]
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .flex {
    display: block;
  }
}
</style>